module.exports = __webpack_public_path__ + "img/IMGP8632b.20b6d50a.jpg";